import CookieBanner from './components/CookieBanner';
import Privacy from './pages/Privacy';
import React from 'react';
import { HashRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Properties from './pages/Properties';
import PropertyDetail from './pages/PropertyDetail';
import Contact from './pages/Contact';
import Estimation from './pages/Estimation';
import Legal from './pages/Legal';
import About from './pages/About';
import Histoire from './pages/Histoire';
import Process from './pages/Process';
import Login from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';
import PropertyForm from './pages/admin/PropertyForm';
import CityManager from './pages/admin/CityManager';
import ProtectedRoute from './pages/admin/ProtectedRoute';

import FixedMobileContact from './components/FixedMobileContact';
import ScrollToTop from './components/ScrollToTop';
import AnalyticsTracker from './components/AnalyticsTracker';
import { SearchProvider } from './context/SearchContext';

function Layout() {
    return (
        <div className="flex flex-col min-h-screen w-full max-w-[100vw] overflow-x-hidden">
            <Header />
            <main className="flex-grow">
                <Outlet />
            </main>
            <CookieBanner />
            <Footer />
            <FixedMobileContact />
            <div className="h-24 md:hidden"></div> {/* Spacer for fixed mobile bar */}
        </div>
    );
}

function App() {
    React.useEffect(() => {
        const CURRENT_VERSION = '2026-04-07-v1';
        const storedVersion = localStorage.getItem('app_version');
        if (storedVersion !== CURRENT_VERSION) {
            if ('serviceWorker' in navigator) {
                navigator.serviceWorker.getRegistrations().then(regs => regs.forEach(r => r.unregister()));
            }
            if ('caches' in window) {
                caches.keys().then(names => names.forEach(n => caches.delete(n)));
            }
            localStorage.setItem('app_version', CURRENT_VERSION);
            if (storedVersion) window.location.reload();
        }
    }, []);

    return (
        <Router>
            <SearchProvider>
                <ScrollToTop />
                <AnalyticsTracker />
                <Routes>
                    {/* Public Routes */}
                    <Route path="/" element={<Layout />}>
                        <Route index element={<Home />} />
                        <Route path="annonces" element={<Properties />} />
                        <Route path="property/:id" element={<PropertyDetail />} />
                        <Route path="contact" element={<Contact />} />
                        <Route path="estimation" element={<Estimation />} />
                        <Route path="agence" element={<About />} />
                        <Route path="histoire" element={<Histoire />} />
                        <Route path="parcours" element={<Process />} />
                        <Route path="mentions-legales" element={<Legal />} />
                        <Route path="politique-de-confidentialite" element={<Privacy />} />
                    </Route>

                    {/* Admin Routes */}
                    <Route path="/admin/login" element={<Login />} />

                    {/* Protected Admin Routes */}
                    <Route path="/admin" element={<ProtectedRoute />}>
                        <Route index element={<Dashboard />} />
                        <Route path="cities" element={<CityManager />} />
                        <Route path="new" element={<PropertyForm />} />
                        <Route path="edit/:id" element={<PropertyForm />} />
                    </Route>
                </Routes>
            </SearchProvider>
        </Router>
    );
}

export default App;
